// Module
var code = `<footer class="HOA-tabbar">
    <a *ngFor="let item of items"
       (click)="pushPopService.navToTab(item.section)"
       class="HOA-tabbar__tab"
       [ngClass]="{'HOA-tabbar__tab--selected': item.section === currentSection}"
       (blur)="onBlur()"
       attr.tid="{{item.tid}}-footer">
               <span [ngClass]="item.section === currentSection ?
                                item.iconClassSelected :
                                item.iconClass" data-grunticon-embed
                     [style.display]="item.hideIcon ? 'none': 'block'"></span>
        <span class="HOA-tabbar__tab-label">{{item.name}}</span>
    </a>
</footer>`;
// Exports
module.exports = code;